import retryCallIfNeeded from '../../../restCalls';

const baseEndpointUrl = '/api/pricing/v1';

export default function PricingService(client) {
  /**
   * GET /api/pricing/v1/benefits?oracleDuns={oracleDuns}
   * Fetch employer benefit details by Oracle DUNS number.
   */
  const getEmployerBenefitByDunsAsync = async oracleDuns =>
    retryCallIfNeeded(client, () =>
      client.get(`${baseEndpointUrl}/benefits`, { params: { oracleDuns } }),
    );

  /**
   * GET /api/pricing/v1/benefits/search?name={name}&benefitCategory={benefitCategory}&showScore={showScore}&semantic={semantic}
   * Search employer benefits by name with optional filters.
   */
  const searchEmployerBenefitsByNameAsync = async ({
    name,
    benefitCategory,
    showScore,
    semantic,
    enableFamilyBenefits,
  }) =>
    retryCallIfNeeded(client, () =>
      client.get(`${baseEndpointUrl}/benefits/search`, {
        params: {
          name,
          benefitCategory,
          showScore,
          semantic,
          ...(enableFamilyBenefits ? { enableFamilyBenefits: true } : {}),
        },
      }),
    );

  return {
    getEmployerBenefitByDunsAsync,
    searchEmployerBenefitsByNameAsync,
  };
}
